<script>
	import LoginView from '@/components/login/LoginView.vue';
	import { mapState } from 'vuex';
	import apiHelper from '@/utils/apiHelpers';
	import store from '@/utils/store';

	export default {
		name: 'header-component',
		components: {
			LoginView
		},
		data() {
			return {
				isUserMenu: false,
				showLoginModal: false,
				logoSrc: require('../../../assets/img/logo.png'),
				logoOnlySrc: require('../../../assets/img/logo-only.png'),
				isLeftMenuOpen: false,
			};
		},
		computed: {
			...mapState([
				'isLoggedIn',
				'loggedUser',
				'isOpenAside',
				'noOfCartProducts',
				'isDarkMode'
			]),
		},
		methods: {
			openLoginModal() {
				this.showLoginModal = true;
			},
            closeLoginModal() {
                this.showLoginModal = false;
            },
			async logout(){
				this.toggleUserMenu();
				await apiHelper.logout(this.$router, this.loggedUser.timelog_id);
			},
			toggleAsideMenu(){
				store.commit('setToggleAsideMenu', !this.isOpenAside);
			},
			toggleUserMenu(){
				this.isUserMenu = !this.isUserMenu
			},
			handleOutsideClick(event) {
				// Close the menu if the click is outside both the navbar and the toggle icon
				const navbar = this.$refs.navbar;
				const menuToggle = this.$refs.menuToggle;
				const menu = this.$refs.userMenu;
				if (
					this.isLeftMenuOpen &&
					!navbar.contains(event.target) &&
					!menuToggle.contains(event.target)
				) {
					this.isLeftMenuOpen = false;
				}

				if (menu && !menu.contains(event.target)) {
					this.isUserMenu = false;
				}
			},
			checkScreenSize() {
				this.isSmallScreen = window.innerWidth <= 768;
			},
			toggleLeftMenu(){
				this.isLeftMenuOpen = !this.isLeftMenuOpen;
			},
		},
		mounted() {
			window.addEventListener("click", this.handleOutsideClick);
			window.addEventListener('resize', this.checkScreenSize);
			this.checkScreenSize();
		},
		beforeUnmount() {
			window.addEventListener("click", this.handleOutsideClick);
			window.removeEventListener('resize', this.checkScreenSize);
		},
    }
</script>